import pRetry from "p-retry";

/**
 * Retry promise (dynamic import of js chunk) a few times on failure with exponential backoff.
 *
 * Recovering from a chunk that no longer exists after a deploy is handled
 * globally by the `vite:preloadError` listener in helpers/chunk-preload-error.ts,
 * which covers every lazy import rather than just this one call site.
 * @param fn promise to retry
 * @returns promise
 */
export async function retryRoute<T>(fn: () => Promise<T>) {
  return pRetry(fn, {
    retries: 4,
  });
}
